import { withStyles } from "@material-ui/core";
import React from "react";
import DatePicker from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import pt from "react-date-object/locales/gregorian_pt_br";

const MultiDatePicker = ({
  classes,
  onChange,
  values,
  calendarPosition = "top-center",
  placeholder = "Selecione",
}) => {
  return (
    <DatePicker
      calendarPosition={calendarPosition}
      multiple
      className={classes.datePicker}
      locale={pt}
      plugins={[
        <DatePanel className={classes.datePanel} header={"Selecionados"} bod />,
      ]}
      format="DD/MM/YYYY"
      mapDays={({ date, selectedDate, today, isSameDate }) => {
        let props = {};

        if (selectedDate) props.className = classes.days;
        if (isSameDate(date, today)) {
          props.className += ` ${classes.today}`;
        }

        if (selectedDate && selectedDate.some((d) => isSameDate(d, date))) {
          props.className += ` ${classes.dateSelected}`;
        }
        return props;
      }}
      placeholder={placeholder}
      inputClass={classes.inputClass}
      onChange={onChange}
      value={values}
    />
  );
};

const styles = () => ({
  datePicker: {
    width: "100%",
    color: "#505050",
    position: "relative",
    "@global": {
      ".rmdp-header-values": {
        color: "#505050",
      },
      ".rmdp-arrow-container:hover": {
        background: "#4F9B97 !important",
      },
      ".rmdp-week-day": {
        color: "#4F9B97 !important",
      },
      ".rmdp-day.rmdp-selected span:not(.highlight)": {
        background: "#4F9B97 !important",
      },
      ".rmdp-day:not(.rmdp-disabled,.rmdp-day-hidden) span:hover": {
        background: "#EAF5F6 !important",
        border: "1px solid #4F9B97",
        color: "#505050 !important",
      },
    },
  },

  inputClass: {
    background: "#f2f2f2",
    width: "100%",
    border: "none",
    height: "32px",
    borderRadius: "8px",
    paddingLeft: "8px",
    fontSize: "12px",
    color: "#505050",
  },

  today: {
    color: "#4F9B97 !important",
    background: "#fff !important",
  },

  days: {
    "&:hover": {
      background: "#EAF5F6 !important",
      border: "1px solid #4F9B97",
      color: "#505050 !important",
    },
    color: "#505050",
  },

  dateSelected: {
    background: "#4F9B97 !important",
    color: "#fff !important",
  },

  datePanel: {
    background: "#EAF5F6 !important",
    borderRadius: "5px",
    "& div ul li": {
      background: "#4F9B97 !important",
      borderRadius: "15px",
      fontSize: "12px !important",
      "& button": {
        background: "#4F9B97 !important",
      },
    },
    "@global": {
      ".rmdp-panel-header": {
        color: "#505050",
        margin: "0",
        padding: "10px",
        fontSize: "14px",
        textAlign: "center",
        background: "#fff",
        borderRadius: "0px 5px 0px 0px",
        boxShadow: "0 0 5px #8798ad",
      },
    },
  },
});

export default withStyles(styles)(MultiDatePicker);
